<div class="site-container">
  <div class="order-container">
    @if (showBack()) {
      <div class="order-back no-print">
        <a routerLink="/my-account/orders" class="back-link" aria-label="Back to Orders">
          <i class="pi pi-arrow-left"></i>
          <span>Back to Orders</span>
        </a>
      </div>
    }
    <div class="order-content" [class.order-content-align-center]="!showPrices">
      <!-- LEFT: order box -->
      <div class="order-box">
        <!-- Header -->
        <div class="order-header">
          <div class="icon">
            <i class="pi pi-check-circle"></i>
          </div>
          <div>
            <h2 class="order-title">Order #{{ order()?.uuid }}</h2>
            <p class="order-thanks">
              Thank You {{ order()?.contact_info?.first_name || order()?.email }}!
            </p>
            <p class="order-subtext">
              Your order {{ order()?.uuid }} is being processed. A confirmation email has been sent
              to
              <strong>{{ order()?.contact_info?.email || order()?.email }}</strong>
              . Please check your inbox for further information.
            </p>
          </div>
        </div>

        <!-- Items -->
        <div class="items-list">
          @for (item of viewItems(); track item.product_size_id; let i = $index) {
            <app-cart-item
              [item]="item"
              [displayCurrency]="order()?.display_currency ?? null"
              [removeIndex]="i"
              [inactive]="false"
              [disablePrices]="disablePrices"
              [hidePrices]="isKitOrder()"
              [readonly]="true"
            />
          } @empty {
            <p>{{ 'CART.noProductMessage' | translate }}.</p>
          }
        </div>

        <div class="divider"></div>

        <!-- Shipping To -->
        @if (order()?.contact_info) {
          <div class="info-block">
            <div class="info-title">
              <i class="pi pi-map-marker"></i>
              Shipping To
            </div>
            <div class="info-body">
              <div>{{ order().contact_info.first_name }} {{ order().contact_info.last_name }}</div>
              <div>{{ order().contact_info.address_1 }}</div>
              @if (order().contact_info.address_2) {
                <div>{{ order().contact_info.address_2 }}</div>
              }
              <div>
                {{ order().contact_info.city }}, {{ order().contact_info.state?.name }}
                {{ order().contact_info.zip }}
              </div>
              <div>
                {{ order().contact_info.country?.full_name || order().contact_info.country?.name }}
              </div>
            </div>
          </div>
        }

        <!-- Shipping Method -->
        <div class="info-block">
          <div class="info-title">
            <i class="pi pi-truck"></i>
            Shipping Method
          </div>
          <div class="info-body">
            {{ shippingMethodName() || '-' }}
          </div>
        </div>

        <!-- Payment Method -->
        @if (!isKitOrder() && !isPaymentDisabled()) {
          <div class="info-block">
            <div class="info-title">
              <i class="pi pi-credit-card"></i>
              Payment Method
            </div>
            <div class="info-body">
              {{ paymentMethodLabel() }}
              @if (resolvedBasePayment(); as payment) {
                <p>
                  Points spent:
                  <strong>{{ payment.points | basePoints: baseCurrency() : true }}</strong>
                </p>
              }
              @if (
                !isBasePayment() &&
                order()?.display_currency &&
                order()?.card_number_last_four &&
                paymentStatus() === 'paid'
              ) {
                <p>
                  Card charged:
                  {{
                    order().total + (order().customer_donation_amount ?? 0)
                      | price
                      | usdPipe: 'USD' : 'symbol' : '1.2-2' : null : true
                  }}
                  USD
                </p>
              }
              @if (!isStoreCredit() && !isBasePayment()) {
                &nbsp;•••• {{ last4() }}
              }
              <p-tag
                [icon]="paymentTagIcon()"
                [severity]="paymentTagSeverity()"
                [value]="paymentTagValue()"
                rounded
              />
            </div>
          </div>
        }

        <p class="order-note">{{ 'ORDER-CONFIRMATION.shippingNote' | translate }}</p>

        <!-- Actions -->
        @if (order()) {
          <div class="actions no-print">
            @if (!isOrderOlderThan60Minutes()) {
              <app-button
                label="Cancel Order"
                [buttonStyle]="'danger'"
                (click)="cancelOrder()"
              ></app-button>
            }
            <app-button
              [label]="'ORDER-CONFIRMATION.goToHomepage' | translate"
              routerLink="/"
            ></app-button>
            <app-button
              [label]="'ORDER-CONFIRMATION.print' | translate"
              buttonStyle="outlined"
              (handleClick)="printPage()"
            ></app-button>
          </div>
        }
      </div>

      <!-- RIGHT: Summary -->
      @if (showPrices) {
        @if (resolvedBasePayment(); as payment) {
          <section class="base-payment-summary" aria-labelledby="base-payment-summary-title">
            <h2 id="base-payment-summary-title">Base payment</h2>
            <div>
              <span>Points spent</span>
              <strong>{{ payment.points | basePoints: baseCurrency() : true }}</strong>
            </div>
            <p>No monetary amount remains due.</p>
          </section>
        } @else {
          <app-order-summary
            [title]="'Summary'"
            [displayCurrency]="order()?.display_currency ?? null"
            [subtotal]="subtotal()"
            [tax]="tax()"
            [shipping]="shipping()"
            [flatOrderFeeAmount]="flatOrderFeeAmount()"
            [flatOrderFeeLabel]="flatOrderFeeLabel()"
            [handlingFeeAmount]="handlingFeeAmount()"
            [discount]="discount()"
            [donation]="order()?.customer_donation_amount ?? 0"
            [totalDue]="totalDue() + (order()?.customer_donation_amount ?? 0)"
          />
        }
      }
    </div>
    <!-- /order-content -->
  </div>
</div>
